module.exports = __webpack_public_path__ + "static/media/qubicaminilogo.604a5c88.png";